import { FC } from 'react';
import NextImage from 'src/shared-components/NextImage/NextImage';
import Constraints from 'src/shared-components/Constraints/Constraints';
import { FormattedMessage } from 'react-intl';
import trns from './trns';

const check = 'shared/check.svg';

const stepsList = [
  {
    step: '1',
    message: trns.step1,
    width: 47,
    height: 50,
    image: 'home/step1.svg'
  },
  {
    step: '2',
    message: trns.step2,
    width: 62,
    height: 41,
    image: 'home/step2.svg'
  },
  {
    step: '3',
    message: trns.step3,
    width: 45,
    height: 45,
    image: 'home/step3.svg'
  },
  {
    step: '4',
    message: trns.step4,
    width: 37,
    height: 43,
    image: 'home/step4.svg'
  }
];

export const stepsContainerId = 'steps-container';

const PartnersContainer: FC = () => {
  return (
    <div className="hidden m:flex m:bg-wildSand m:h-60" id={stepsContainerId}>
      <Constraints className="w-full">
        <div className="flex flex-col w-full p-10 items-center justify-center">
          <section className="flex w-full step-indicator flex items-center justify-between">
            {stepsList.map((item, index) => {
              return (
                <div className="flex w-full items-center" key={index}>
                  <div className="flex items-center relative flex-col before:transform before:-translate-x-1/2 before:left-2/4">
                    <div className="justify-center rounded-full h-10 w-10 text-astronautBlue fs-header5-bold flex items-center bg-white">
                      {item.step}
                    </div>
                    <div className="absolute top-12 -left-10 inset-x-0 flex justify-center items-start m:w-52 xl:w-72">
                      <div className="px-4 pt-2.5">
                        <NextImage
                          alt="step 1"
                          src={item.image}
                          layout="fixed"
                          height={item.height}
                          width={item.width}
                        />
                      </div>
                      <span className="fs-body-reg text-mako">
                        <FormattedMessage {...item.message} />
                      </span>
                    </div>
                  </div>
                  <div className="w-full flex-1 border-t-2 border-dotted border-gray60" />
                </div>
              );
            })}
            <div className="flex items-center relative flex-col before:transform before:-translate-x-1/2 before:left-2/4">
              <div className="justify-center rounded-full h-10 w-10 text-astronautBlue fs-header5-bold flex items-center bg-white">
                <NextImage
                  alt="check"
                  src={check}
                  layout="fixed"
                  height={16}
                  width={21}
                />
              </div>
              <div className="absolute top-12 inset-x-0 w-8 flex justify-center items-center">
                <span className="fs-body-reg text-astronautBlue">
                  <FormattedMessage {...trns.step5} />
                </span>
              </div>
            </div>
          </section>
        </div>
      </Constraints>
    </div>
  );
};

export default PartnersContainer;
